
import React from 'react'
// import { NavLink } from 'react-router-dom'
import { swiperList } from '@/constants'

function NavItem () {
    return (
        swiperList.map((item, index) => {
            return (
                <div className="swiper-slide lx-w100" key={index} >
                    {/* <img className="lx-image-rendering banner-img" src={item.imgUrl} alt="banner" /> */}
                    <div className="banner-img" style={{backgroundImage: `url('${item.imgUrl}')`}}></div>
                </div>
            )
        })
    ) 
}


export default NavItem;